import user from "../data/user.json";

const Root = () => {
    return (
        <div data-testid="Root" className="root">
            {user.photoUrl && <img className="root-user-photo" width="150" height="150" alt={user.title ? user.title : "User Image"} src={user.photoUrl} />}

            {user.title && <h1 data-testid="RootTitle" className="root-title">{user.title}</h1>}

            {user.subtitle && <p data-testid="RootSubtitle" className="root-subtitle">{user.subtitle}</p>}
        </div>
    )
}

export default Root;